export const getCountryCodeFromOneTrust = (): string => {
  try {
    if (typeof window !== 'undefined' && 'OneTrust' in window) {
      const oneTrust = window.OneTrust;
      if (oneTrust && typeof oneTrust.getGeolocationData === 'function') {
        const geoData = oneTrust.getGeolocationData();
        if (geoData && geoData.country) {
          return geoData.country.toUpperCase();
        }
      }
    }

    return 'US';
  } catch (error) {
    console.error('Error getting country code from consent:', error);
    return 'US';
  }
};
